var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"base-el-scrollbar",class:{ 'is-hori': !_vm.vertical }},[_c('el-scrollbar',_vm._b({ref:"elScrollbarRef",attrs:{"vertical":_vm.vertical},on:{"wheel":_vm.wheelHandler}},'el-scrollbar',_vm.$attrs,false),[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }